import type { TableFilterField } from '@shared/ui';
import type { CandidateFiltersForm } from './types';

export const candidateFiltersConfig: TableFilterField[] = [
  {
    name: 'createdAt',
    label: 'Дата создания',
    type: 'date-range',
    placeholder: 'Все',
  },
  {
    name: 'id',
    label: 'ID',
    type: 'number',
    placeholder: 'Все',
  },
  {
    name: 'phone',
    label: 'Номер телефона',
    type: 'phone',
    placeholder: 'Все',
  },
  {
    name: 'fullName',
    label: 'Фамилия Имя',
    type: 'text',
    placeholder: 'Все',
  },
  // {
  //   name: 'city',
  //   label: 'Город',
  //   type: 'select-city',
  //   placeholder: 'Все',
  //   apiKey: 'cities.name',
  // },
  // {
  //   name: 'salaryRange',
  //   label: 'Уровень дохода',
  //   type: 'range',
  //   fromName: 'salaryFrom',
  //   toName: 'salaryTo',
  //   placeholderFrom: 'от',
  //   placeholderTo: 'до',
  //   apiKey: 'salary',
  // },
  {
    name: 'interviewRequired',
    label: 'Интервью',
    type: 'select',
    options: [
      { value: '', label: 'Все' },
      { value: 'true', label: 'Требует участия' },
      { value: 'false', label: 'Не требует участия' },
    ],
    clearable: true,
    placeholder: 'Все',
  },
  {
    name: 'status',
    label: 'Статус',
    type: 'select',
    options: [
      { value: '', label: 'Все' },
      { value: 'NEW', label: 'Новый' },
      { value: 'LOOKING', label: 'Ищет работу' },
      { value: 'EMPLOYED', label: 'Работает' },
      { value: 'CONSIDERING', label: 'Рассматривает предложения' },
      { value: 'NOT_LOOKING', label: 'Не ищет работу' },
    ],
    clearable: true,
    placeholder: 'Все',
  },
];

export const initialValues: CandidateFiltersForm = {
  createdAt: [null, null],
  id: '',
  phone: '',
  fullName: '',
  city: [],
  salaryFrom: '',
  salaryTo: '',
  interviewRequired: null,
  status: null,
};
